export default "__VITE_ASSET__C6ao8Ttd__"